<div class="confirm-modal ig-modal set-contacts-modal">


    <div [formGroup]="hubContactsForm">
        <mat-tab-group>
            <mat-tab>
                <ng-template mat-tab-label>
                    Client URLs
                </ng-template>
                <div class="m-t-3">
                    <ig-row *ngIf="shouldShowSsrDetailAvailabilityToggles">
                        <ig-col [xs]="12" [md]="12">
                            <div style="text-align:left;font-weight:600;margin-bottom:10px;display:flex;align-items:center;gap:8px;">
                                <span>Client SSR Detail Availability</span>
                                <span
                                    style="display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border-radius:50%;border:1px solid #b8b8b8;color:#666;font-size:12px;cursor:help;"
                                    matTooltip="These settings affect how event and place detail pages are opened from Itinerary and AI TripPlanner. When enabled, they open the client website's SSR detail URLs. When disabled, they fall back to our Angular modal presentation of the new SSR detail UI."
                                >?</span>
                            </div>
                        </ig-col>
                    </ig-row>
                    <ig-row *ngIf="shouldShowSsrDetailAvailabilityToggles">
                        <ig-col [xs]="12" [md]="12" style="text-align:left;" class="m-b-4">
                            <div style="display:flex;flex-direction:column;align-items:flex-start;gap:8px;">
                                <mat-checkbox [(ngModel)]="contact.eventsSsrEnabled" [ngModelOptions]="{standalone: true}">
                                    Client website has Events SSR enabled
                                </mat-checkbox>
                                <mat-checkbox [(ngModel)]="contact.placesSsrEnabled" [ngModelOptions]="{standalone: true}">
                                    Client website has Places SSR enabled
                                </mat-checkbox>
                            </div>
                        </ig-col>
                    </ig-row>
                    <ig-row>
                        <ig-col [xs]="12" [md]="12">
                            <ig-field label="Client site event calendar URL" [required]="false"
                                [formControl]="hubContactsForm.get('event')" icon="date_range"
                                [(ngModel)]="contact.eventCalendarURL">
                            </ig-field>
                        </ig-col>
                    </ig-row>
                    <ig-row>
                        <ig-col [xs]="12" [md]="12">
                            <ig-field label="Client site itinerary URL" [required]="false"
                                [formControl]="hubContactsForm.get('tour')" icon="room"
                                [(ngModel)]="contact.moreToursURL">
                            </ig-field>
                        </ig-col>
                    </ig-row>
                    <!-- <ig-row>
                        <ig-col [xs]="12" [md]="12">
                            <ig-field label="Client site place calendar URL" [required]="false"
                                [formControl]="hubContactsForm.get('place')" icon="room"
                                [(ngModel)]="contact.placeCalendarURL">
                            </ig-field>
                        </ig-col>
                    </ig-row> -->
                    <ig-row>
                        <ig-col [xs]="12" [md]="12">
                            <ig-accordion id="place-type" icon="room" title="Places URL Mapping (expand to set)"
                                class="m-t-2">
                                <div style="max-height:400px;overflow:auto" formArrayName="dynamicFields">

                                    <form [formGroup]="placeForm" class="url-form">
                                        <div formArrayName="dynamicFields">
                                            <div *ngFor="let field of getControls(); let i = index" [formGroupName]="i"
                                                style="margin-bottom: 32px;">
                                                <div style="text-align: left;margin-bottom: 6px;color:gray">Group
                                                    {{i+1}}</div>
                                                <input formControlName="igURL" type="text"
                                                    placeholder="ImGoing place category URL">
                                                <input formControlName="clientURL" type="text"
                                                    placeholder="Client website place category URL">
                                            </div>
                                        </div>
                                    </form>
                                    <div item style="color:#41abf3;cursor:pointer" (click)="addPlaceURL()">+ Add</div>
                                </div>
                            </ig-accordion>
                        </ig-col>
                    </ig-row>

                </div>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    Contacts
                </ng-template>

                <div>
                    <ig-row>
                        <ig-col [xs]="12" [md]="6">
                            <ig-field label="Name" [required]="true" [formControl]="hubContactsForm.get('name')"
                                icon="people" [(ngModel)]="contact.name">
                            </ig-field>
                        </ig-col>
                        <ig-col [xs]="12" [md]="6">
                            <ig-field label="Phone Number" [formControl]="hubContactsForm.get('number')"
                                icon="local_phone" type="number" [(ngModel)]="contact.number">
                            </ig-field>
                        </ig-col>
                    </ig-row>
                    <ig-row>
                        <ig-col [xs]="12">
                            <ig-field label="Email" [formControl]="hubContactsForm.get('email')" icon="mail_outline"
                                [(ngModel)]="contact.email">
                            </ig-field>
                        </ig-col>
                    </ig-row>

                    <br />
                    <p>Client trip inquiry contact email</p>
                    <ig-row>
                        <ig-col [xs]="12">
                            <ig-field label="Email" [formControl]="hubContactsForm.get('inquiryEmail')"
                                icon="mail_outline" [(ngModel)]="contact.inquiryEmail">
                            </ig-field>
                        </ig-col>
                    </ig-row>

                </div>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    Webhook
                </ng-template>

                <div class="m-t-3 webhook-tab">
                    <div class="webhook-tab__section">
                        <mat-checkbox [(ngModel)]="webhookSettings.enabled"
                            [ngModelOptions]="{standalone: true}">
                            Enable SSR cache invalidation webhook
                        </mat-checkbox>
                    </div>

                    <ig-row class="m-t-2">
                        <ig-col [xs]="12" [md]="12">
                            <ig-field label="Webhook URL" [required]="false" icon="link"
                                [formControl]="hubContactsForm.get('webhookUrl')"
                                [(ngModel)]="webhookSettings.endpointUrl">
                            </ig-field>
                        </ig-col>
                    </ig-row>

                    <ig-row>
                        <ig-col [xs]="12" [md]="12">
                            <ig-field label="Signing Secret" [required]="false" icon="vpn_key"
                                [formControl]="hubContactsForm.get('signingSecret')"
                                [(ngModel)]="webhookSettings.signingSecret">
                            </ig-field>
                            <!-- <div class="webhook-tab__action" (click)="generateWebhookSecret()">
                                Generate secret
                            </div> -->
                        </ig-col>
                    </ig-row>

                    <div class="webhook-tab__section">
                        <p class="webhook-tab__label">Webhook subscriptions</p>
                        <div class="webhook-tab__subscription">
                            <mat-checkbox [(ngModel)]="webhookSettings.sendEventDetailInvalidation"
                                [ngModelOptions]="{standalone: true}">
                                Event detail cache invalidation
                            </mat-checkbox>
                            <span class="webhook-tab__help" matTooltip="When enabled, we send a webhook after an event detail page may need to be refreshed, such as when an event is created, updated, unpublished, restored, or removed. The receiving plugin can use this to clear cached event detail content.">?</span>
                        </div>
                        <div class="webhook-tab__subscription">
                            <mat-checkbox [(ngModel)]="webhookSettings.sendEventListingInvalidation"
                                [ngModelOptions]="{standalone: true}">
                                Event listing cache invalidation
                            </mat-checkbox>
                            <span class="webhook-tab__help" matTooltip="When enabled, we send a webhook after event changes that may affect the public event listing page, such as event creation, title or image updates, pinned status changes, approval changes, removals, or deletions. The receiving plugin can use this to clear cached event listing content.">?</span>
                        </div>
                        <div class="webhook-tab__subscription">
                            <mat-checkbox [(ngModel)]="webhookSettings.sendPlaceDetailInvalidation"
                                [ngModelOptions]="{standalone: true}">
                                Place detail cache invalidation
                            </mat-checkbox>
                            <span class="webhook-tab__help" matTooltip="When enabled, we send a webhook after a place detail page may need to be refreshed, such as when a place is created, updated, unpublished, restored, or removed. The receiving plugin can use this to clear cached place detail content.">?</span>
                        </div>
                        <div class="webhook-tab__subscription">
                            <mat-checkbox [(ngModel)]="webhookSettings.sendPlaceListingInvalidation"
                                [ngModelOptions]="{standalone: true}">
                                Place listing cache invalidation
                            </mat-checkbox>
                            <span class="webhook-tab__help" matTooltip="When enabled, we send a webhook after place changes that may affect the public place listing page, such as place creation, title or image updates, pinned status changes, approval changes, removals, or deletions. The receiving plugin can use this to clear cached place listing content.">?</span>
                        </div>
                        <div class="webhook-tab__subscription">
                            <mat-checkbox [(ngModel)]="webhookSettings.sendItineraryDetailInvalidation"
                                [ngModelOptions]="{standalone: true}">
                                Itinerary detail cache invalidation
                            </mat-checkbox>
                            <span class="webhook-tab__help" matTooltip="When enabled, we send a webhook after an itinerary detail page may need to be refreshed. The receiving plugin can refresh all pages selected under Itinerary Detail Content Pages.">?</span>
                        </div>
                        <div class="webhook-tab__subscription">
                            <mat-checkbox [(ngModel)]="webhookSettings.sendItineraryListingInvalidation"
                                [ngModelOptions]="{standalone: true}">
                                Itinerary listing cache invalidation
                            </mat-checkbox>
                            <span class="webhook-tab__help" matTooltip="When enabled, we send a webhook after itinerary changes that may affect public itinerary listings. The receiving plugin can refresh all pages selected under Itineraries Listing Pages.">?</span>
                        </div>
                        <div class="webhook-tab__subscription">
                            <mat-checkbox [(ngModel)]="webhookSettings.sendSsrModuleStatusUpdate"
                                [ngModelOptions]="{standalone: true}">
                                SSR module status updates
                            </mat-checkbox>
                            <span class="webhook-tab__help" matTooltip="When enabled, we send a webhook after DXP Admin changes the effective public SSR availability of events, places, itineraries, or Trip Planner. The receiving plugin can use the full module snapshot to update its module settings.">?</span>
                        </div>
                    </div>

                    <!-- <div class="webhook-tab__note">
                        Canonical URLs for webhook payloads will be generated from
                        <code>contacts.eventCalendarURL</code> and
                        <code>contacts.placeCalendarURL</code>.
                    </div> -->
                </div>
            </mat-tab>
        </mat-tab-group>

        <ig-success-wrap #success>
            <ig-button size="md" [isAsync]="true" class="ig-blue-btn m-t-4" (trigger)="save($event)">save</ig-button>
        </ig-success-wrap>
    </div>
</div>



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/set.contacts/set.contacts.modal.component.html